<template>
  <Transition name="modal">
    <div v-if="show" class="photo-modal" @click="close">
      <div class="modal-content" @click.stop>
        <button class="close-button" @click="close">&times;</button>
        <img :src="photoUrl" :alt="alt" class="modal-image" @click.stop />
      </div>
    </div>
  </Transition>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PhotoModal',
  props: {
    show: Boolean,
    photoUrl: String,
    alt: String
  },
  emits: ['close'],
  setup(props, { emit }) {
    const close = () => {
      emit('close');
    };

    return { close };
  }
});
</script>

<style scoped>
.photo-modal {
  position: fixed;
  top: 10%;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.9);
  animation: fadeIn 0.3s ease-out;
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
  filter: none !important;
}

.modal-image {
  display: block;
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.5);
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.close-button:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Add transition animations */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

/* Add mobile-specific styles */
@media (max-width: 768px) {
  .photo-modal {
    top: 0;
    padding: 0.5rem;
    height: 100%;
  }

  .modal-content {
    max-width: 95%;
    max-height: 75vh;
    width: auto;
    margin: auto;
  }

  .modal-image {
    max-height: 65vh;
    width: auto;
    max-width: 100%;
  }

  .close-button {
    top: 15px;
    right: 15px;
    width: 32px;
    height: 32px;
    font-size: 18px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1010;
  }
}

/* Additional adjustments for very small screens */
@media (max-width: 480px) {
  .photo-modal {
    padding: 0.5rem;
  }

  .modal-content {
    max-width: 98%;
    max-height: 70vh;
  }

  .modal-image {
    max-height: 60vh;
  }

  .close-button {
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    font-size: 16px;
  }
}
</style>
